<template>
  <div class="container">
    <h2 class="section-title">금융지원 안내</h2>

    <div class="finance-list">
      <div v-for="(item, index) in financeSupports" :key="index" class="finance-card">
        <div class="finance-header">
          <div class="finance-number">{{ index + 1 }}</div>
          <h3 class="finance-title">{{ item.title }}</h3>
        </div>
        <div class="finance-details">
          <span class="finance-info">보증금: {{ item.deposit }}</span>
          <span class="finance-info">연금리: {{ item.interestRate }}</span>
        </div>
        <div class="finance-buttons">
          <div class="button-group" :class="item.buttons.length === 1 ? 'full-width' : ''">
            <template v-if="item.buttons.length === 1">
              <a :href="item.buttons[0].url" target="_blank" rel="noopener noreferrer" class="detail-button full-width">
                {{ item.buttons[0].label }}
              </a>
            </template>
            <template v-else>
              <a v-for="(btn, btnIndex) in item.buttons" :key="btnIndex" :href="btn.url" target="_blank" rel="noopener noreferrer" class="tag-button half-width">
                {{ btn.label }}
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
      <section class="notice-section">
        <div class="notice-text">
          * 자세한 내용은 서울시 서울주택도시공사 1600-3456 문의 또는 
          <a href="https://soco.seoul.go.kr/youth/main/contents.do?menuNo=400021" target="_blank" class="notice-link">서울시 청년안심주택 홈페이지[금융지원]</a> 
          참조하시기 바랍니다.
        </div>
      </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      financeSupports: [
        // {
        //   title: "역세권 청년주택 주거비 지원",
        //   deposit: "최대 50%",
        //   interestRate: "무이자",
        //   buttons: [
        //     { label: "상세내용 확인하기", url: "https://housing.seoul.go.kr/site/main/content/sh01_060508" }
        //   ]
        // },
        // {
        //   title: "서울시 임차보증금 이자지원사업",
        //   deposit: "최대 90%",
        //   interestRate: "최저 1%",
        //   buttons: [
        //     { label: "청년", url: "https://housing.seoul.go.kr/site/main/content/sh01_040901" },
        //     { label: "신혼부부", url: "https://housing.seoul.go.kr/site/main/content/sh01_0400800" }
        //   ]
        // },
        {
          title: "중소기업취업청년 전월세보증금대출",
          deposit: "최대 100%",
          interestRate: "1.2%",
          buttons: [
            { label: "상세내용 확인하기", url: "https://nhuf.molit.go.kr/FP/FP05/FP0502/FP05020701.jsp" }
          ]
        },
        {
          title: "버팀목 전세자금 대출",
          deposit: "최대 70-80%",
          interestRate: "1.0-2.9%",
          buttons: [
            { label: "청년", url: "https://nhuf.molit.go.kr/FP/FP05/FP0502/FP05020301.jsp" },
            { label: "신혼부부", url: "https://nhuf.molit.go.kr/FP/FP05/FP0502/FP05020401.jsp" }
          ]
        },
      ],
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Noto Sans KR', sans-serif;
  color: #333;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
}

.finance-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.finance-card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.finance-card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.finance-header {
  display: flex;
  align-items: center;
  flex: 2;
  min-width: 200px;
}

.finance-number {
  font-size: 1.4rem;
  font-weight: bold;
  margin-right: 10px;
  color: #007bff;
}

.finance-title {
  font-size: 1.2rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.finance-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  min-width: 180px;
}

.finance-info {
  font-size: 1rem;
  color: #666;
  text-align: left;
}

.finance-buttons {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.button-group {
  display: flex;
  gap: 10px;
  width: 100%;
}

.button-group.full-width .detail-button {
  width: 100%;
}

.button-group .half-width {
  flex: 1;
}

.detail-button,
.tag-button {
  padding: 12px 16px;
  border: none;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
  text-decoration: none;
  background-color: #4caf50;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.detail-button {
  background-color: #007bff;
}

.detail-button:hover,
.tag-button:hover {
  background-color: #0056b3;
}


.notice-section {
  background-color: #f5f5f5; /* ✅ 연한 회색 배경 */
  padding: 16px 24px;
  margin: 20px auto;
  border-radius: 8px;
  width: 100%;
  max-width: 1200px;
  text-align: left;
}

.notice-text {
  font-size: 0.9rem;
  color: #666; /* ✅ 회색 글씨 */
  line-height: 1.5;
}

.notice-link {
  color: #007bff; /* ✅ 링크는 파란색으로 강조 */
  text-decoration: none;
}

.notice-link:hover {
  text-decoration: underline; /* ✅ 링크 호버 시 밑줄 */
}

@media (max-width: 768px) {
  .finance-card {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px;
  }

  .finance-header {
    flex: unset;
    margin-bottom: 10px;
  }

  .finance-details {
    font-size: 0.9rem;
    min-width: unset;
  }

  .finance-buttons {
    width: 100%;
    padding-top: 10px;
    justify-content: center;
  }

  .button-group {
    flex-direction: column;
    gap: 10px;
  }

  .detail-button,
  .tag-button {
    width: 100%;
  }
}
</style>
